import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import { Button, Divider, Typography } from '@mui/material';

export const TitleText = styled(Typography)`
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
`;

export const StyledDivider = styled(Divider)`
  margin-top: 24px;
`;

export const StyledContainer = styled.div`
  padding: 20px 0px;
`;

export const BodyText = styled(Typography)`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.44px;
`;

export const CancelCTA = styled(Button)`
  color: ${({ theme }) => theme.palette.primary.main};
  width: 172px;
  margin-left: 15px;
  border: 2px solid ${({ theme }) => theme.palette.primary.main};
  height: 50px;
  font-size: 14px;
  text-transform: none;

  @media screen and (max-width: 420px) {
    width: 100%;
    margin: 0px;
    margin-bottom: 16px;
  }
`;

export const UpdateCTA = styled(LoadingButton)`
  color: ${({ theme }) => theme.palette.primary.contrastText};
  width: 170px;
  height: 50px;
  margin-left: 15px;
  font-size: 14px;
  box-shadow: none;
  text-transform: inherit;
  background-color: ${({ theme }) => theme.palette.primary.main};

  @media screen and (max-width: 420px) {
    width: 100%;
    margin: 0px;
  }
`;

export const UpdateChangesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 6px;

  @media screen and (max-width: 420px) {
    flex-direction: column;
  }
`;
